import React from'react';import PropTypes from'prop-types';import styles from"./style";/**
 * The select item component.
 * @param {Object} props - The component props.
 * @param {React.Children} props.children - Some content to display inside.
 * @returns {JSX}
 */var SelectItem=function SelectItem(props){return React.createElement("div",{className:"".concat(styles," ").concat(props.className),onTouchEnd:function onTouchEnd(){return props.onSelect(props.value,props.label);}},props.label);};/**
 * The component prop types.
 * @type {Object}
 */ /**
 * The component default props.
 * @type {Object}
 */SelectItem.defaultProps={className:''};export default SelectItem;